import { render, staticRenderFns } from "./strategy-details-card.component.vue?vue&type=template&id=a210d8ec"
import script from "./strategy-details-card.component.vue?vue&type=script&lang=js"
export * from "./strategy-details-card.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports